<template>
  <div
    :class="computedClass"
    class="CardComponent shadow min-h-64"
  >
    <div
      v-if="image"
      :class="{ 'w-2/5': horizontal, 'h-64': !horizontal }"
      :style="{ backgroundImage: `url(${image})`}"
      class="CardImage bg-cover bg-center bg-no-repeat"
    />
    <div class="CardBody flex flex-col flex-1 p-6 text-left">
      <div class="CardTitle mb-2 font-bold text-xl leading-normal">{{ title }}</div>
      <div class="CardContent">
        <slot>{{ content }}</slot>
      </div>
      <div
        :class="{'bg-orange': type === 'red', 'bg-red': type === 'orange'}"
        class="CardSeparator w-16 h-2px my-3"
      />
      <div
        v-if="link"
        class="CardLink mt-auto"
      >
        <a
          :class="`is-${type}`"
          :href="link"
          class="button is-filled is-sm px-4 py-3"
        >
          Научи повече
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'orange',
      validate: (type) => ['orange', 'red'].includes(type)
    }
  },
  computed: {
    computedClass () {
      return {
        flex: this.horizontal,
        'flex-row-reverse': this.horizontal,
        [`CardComponent--${this.type}`]: true
      }
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import 'utils';
</style>
